import React, { useState, useEffect } from 'react'
import Pagination from 'react-js-pagination';
import CommonIcon from "../helpers/icons";
import { useSelector } from 'react-redux';
import Select from "react-select";
import $ from "jquery";

export default function PaginationComponent(props) {
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(20);
  const [iswebMobile, setWebMobile] = useState();
  const [pageValue, setPageValue] = useState();
  let { documentList, menuToggle } = useSelector((state) => ({
    menuToggle: state.commonReducer.menuToggle
  }));
  const paginglist = [{ "label": "5", "value": 5 }, { "label": "10", "value": 10 }, { "label": "20", "value": 20 }, { "label": "50", "value": 50 }]
  const paginglistDefault = [{ "label": "20", "value": 20 }]

  const [isMobile, setisMobile] = useState(false);

  useEffect(() => {
    const intervals = setInterval(() => {
      resize()
    }, 10);
    return () => clearInterval(intervals);

  }, []);


  const resize = () => {
    if (window.innerWidth < 850) { setisMobile(true) }
    else { setisMobile(false) }

    if (window.innerWidth < 400) {
      setWebMobile(true)
    } else {
      setWebMobile(false)
    }
  }


  /////////////////////////////////// pagination /////////////////////////////////////////
  const handlePageChange = (pageNumber) => {
    
    $(".table-list-view-bottom").scrollTop(0);
    $(".table-list-view-bottom").scrollLeft(0);
    setCurrentPage(pageNumber);
    callPropFunction(pageNumber, perPage);
  }

  const find = (e) => {
    setPageValue(e)
    const perPageValue = parseInt(e.value);
    const selectedPage = 1;
    setPerPage(perPageValue);
    setCurrentPage(selectedPage)
    callPropFunction(selectedPage, perPageValue);
  };
  useEffect(()=>{
    setCurrentPage(1); 
   },[props.reset])


  const callPropFunction = (currentPage, perPage) => {
 props.fetchPagination(currentPage, perPage);
  };

  return (
 
    <>
     { props.pageCount > 0 && 
    <div
      className={`${isMobile ? "common-mobilesubmenu mobile-pagination"
          : menuToggle ? "common-submenu sidemenu-pagination" : "common-submenu web-pagination"} pb-2 pt-2`}>

      <table width="100%">
        <tbody>
          <tr>
            <td width="8%" className="p-3">
              <div className={`${iswebMobile ? "mobilePageSelect" : "webpageSelect"}`}>
                <Select
                  options={paginglist}
                  // defaultValue={paginglistDefault}
                  value={pageValue ? [pageValue] : paginglistDefault}
                  classNamePrefix="paging"
                  isSearchable={false}
                  menuPlacement={"top"}
                  menuPosition={"fixed"}
                  onChange={(e) => find(e)}
                />
              </div>
            </td>
            <td width="92%" className="text-end p-3">
              {isMobile ?
                <Pagination
                  prevPageText={<>{" "}   <CommonIcon fileName="LeftArrowIcon" /> </>}
                  nextPageText={<>   <CommonIcon fileName="RightArrowIcon" />{" "}</>}
                  linkClassNext="nextArrow"
                  linkClassPrev="prevArrow"
                  itemClass={`page-item page-width-mobile`}
                  linkClass="page-link"
                  pageRangeDisplayed={1}
                  onChange={e => handlePageChange(e)}
                  activePage={currentPage}
                  totalItemsCount={props.pageCount}
                  itemsCountPerPage={perPage}
                /> :
                <Pagination
                   prevPageText={<>{" "}   <CommonIcon fileName="LeftArrowIcon" /> </>}
                  nextPageText={<>   <CommonIcon fileName="RightArrowIcon" />{" "}</>}
                  linkClassNext="nextArrow"
                  linkClassPrev="prevArrow"
                  itemClass={`page-item page-width`}
                  linkClass="page-link"
                  pageRangeDisplayed={4}
                  onChange={e => handlePageChange(e)}
                  activePage={currentPage}
                  totalItemsCount={props.pageCount}
                  itemsCountPerPage={perPage}
                />}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  }
    </>

  )
}
